<template>
  <div class="project-container">
    <el-card>
      <template #header>
        <el-button style="margin-bottom: 20px; margin-right: 10px;" type="primary"
          @click="showAddDialog">新增订单</el-button>
        <el-button style="margin-bottom: 20px; margin-right: 10px;" type="danger"
          :disabled="showCustomerFirstProjectsMode" @click="filterWarningProjects">未收款预警</el-button>
        <el-button style="margin-bottom: 20px; margin-right: 10px;" :type="showCompleteProjects ? 'primary' : 'warning'"
          :disabled="showCustomerFirstProjectsMode" @click="filterCompleteProjects">{{ showCompleteProjects ? '显示所有订单' :
            '已完成(关闭)订单' }}</el-button>
        <el-button v-if="isAdmin" style="margin-bottom: 20px;" type="success" @click="showCustomerFirstProjects">{{
          showCustomerFirstProjectsMode ? '显示未完成订单' : '显示客户第一笔订单' }}</el-button>
        <el-button style="margin-bottom: 20px;" type="success" @click="exportSelectedProjects"
          :disabled="selectedProjectIds.length === 0">导出Excel</el-button>
        <el-dropdown style="float: right;">
          <el-button style="margin-bottom: 20px;" type="primary">
            显示列控制 <el-icon class="el-icon--right"><arrow-down /></el-icon>
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- <el-dropdown-item>
                <el-checkbox v-model="columnVisible.customerName">客户名称</el-checkbox>
              </el-dropdown-item> -->
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.contactPerson">联系人</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.contactInfo">联系方式</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.aplicationDate">申请时间</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.status">当前状态</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.type">订单类型</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.estimatedAmount">预估贷款金额(万)</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.totalAmount">贷款金额(万)</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.salesRate">销售费率%</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.purchaseRate">采购费率%</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.taxRate">税率%</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.prePaid">客户余额</el-checkbox>
              </el-dropdown-item>
              <!-- <el-dropdown-item>
                <el-checkbox v-model="columnVisible.deposite">预付金额</el-checkbox>
              </el-dropdown-item> -->
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.completedAmount">已完成金额</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.balance">服务费</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.taxes">税金</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.leftAmount">订单余额</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.unpaidAmount">未收款金额</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.userName">负责人</el-checkbox>
              </el-dropdown-item>
              <el-dropdown-item>
                <el-checkbox v-model="columnVisible.comment">备注</el-checkbox>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="订单名称">
            <el-input v-model="searchForm.name" placeholder="请输入订单名称"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="searchForm.customerName" placeholder="请输入客户名称"></el-input>
          </el-form-item>
          <el-form-item label="联系人">
            <el-input v-model="searchForm.contactPerson" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="负责人">
            <el-input v-model="searchForm.username" placeholder="请输入负责人"></el-input>
          </el-form-item>
          <!--<el-form-item label="申请月份">
            <el-date-picker v-model="searchForm.aplicationDate" type="month" format="YYYY-MM" value-format="YYYY-MM"
              placeholder="请选择申请月份"></el-date-picker>
          </el-form-item>-->
          <el-form-item label="当前状态">
            <el-select v-model="searchForm.status" placeholder="请选择当前状态" style="width: 100px">
              <el-option v-for="status in Object.values(ProjectStatus)" :key="status.value" :label="status.label"
                :value="status.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单月份">
            <el-date-picker v-model="searchForm.orderMonth" type="month" format="YYYY-MM" value-format="YYYY-MM"
              placeholder="请选择订单月份"></el-date-picker>
          </el-form-item>
          <el-form-item label="订单类型">
            <el-select v-model="searchForm.type" placeholder="请选择订单类型" style="width: 100px">
              <el-option label="销售订单" value="Sales"></el-option>
              <el-option label="采购订单" value="Purchase"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
        <!-- 列控制区域已移动到按钮区域 -->
      </template>
      <el-table :data="filteredProjects" :row-class-name="rowClassName" style="width: 100%; overflow-x: auto;"
        row-key="id" lazy :tree-props="{ children: 'payments', hasChildren: 'hasChildren' }" :load="loadPayments"
        @expand-change="handleExpandPayment" @selection-change="handleSelectionChange"
        :header-cell-style="{ width: '100%', height: '20px', color: '#303133' }">
        <!-- :style="{width: '100%', height: `${(scope.row.payments.length+1)*36+1}px`}" -->
        <!-- 扩展内容区域 -->
        <el-table-column type="expand">
          <template #default="scope">
            <div class="expand-scroll-container">
              <div class="expand-content">
                <div v-if="scope.row?.payments?.length > 0" class="sub-table-container" style="width: 100%;">
                  <div class="sub-table-header"
                    style="font-weight: bold; padding: 1px 0; margin-bottom: 2px; border-bottom: 1px solid #e6e6e6; text-align: center; color: #303133;">
                    {{ scope.row.name }}的收款凭证</div>
                  <el-table :data="scope.row?.payments || []" style="width: 100%;" :scroll-x="true"
                    :header-cell-style="{ width: '100%', height: '16px', color: '#303133', background: '#F5F7FA', fontSize: '12px' }">

                    <el-table-column prop="type" label="收款类型">
                      <template #default="scope">
                         <span :style="{ color: scope.row.type === 1 ? '#67c23a' : '#409eff' }">
                          {{ scope.row.type === 1 ? '预付款' : '收款' }}
                         </span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="createTime" label="收款时间"></el-table-column>
                    <el-table-column prop="operator.username" label="收款人"></el-table-column>
                    <el-table-column prop="auditedTime" label="审核时间"></el-table-column>
                    <el-table-column prop="auditor.username" label="审核人"></el-table-column>
                    <el-table-column prop="amount" label="收款金额"></el-table-column>
                    <el-table-column prop="attachmentPath" label="收款凭证">
                      <template #default="scope1">
                        <el-image style="width: 80px; height: 30px;" :src="scope1.row.attachmentPath" :zoom-rate="1.2"
                          :max-scale="7" :min-scale="0.2" :preview-src-list="[scope1.row.attachmentPath]" />
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200" fixed="right">
                      <template #default="scope2">
                        <div class="project-buttons-container">
                          <template v-for="button in getOperationButtons(scope.row, scope2.row)" :key="button.key">
                            <el-button size="small" :type="button.type" @click="button.action(scope2.row, scope.row)"
                              :disabled="button.disabled">
                              {{ button.label }}
                            </el-button>
                          </template>
                        </div>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 主表列 -->
        <el-table-column type="selection" width="30"></el-table-column>
        <el-table-column prop="orderMonth" label="订单月份" fixed="left" width="100"></el-table-column>
        <el-table-column prop="name" label="订单名称" fixed="left" width="80"></el-table-column>
        <!-- <el-table-column prop="companyName" label="企业名称"></el-table-column> -->
        <!-- <el-table-column min-width="154px;" prop="tin" label="纳税人识别码"></el-table-column> -->
        <el-table-column prop="customer.name" label="客户名称" fixed="left"></el-table-column>
        <el-table-column v-if="columnVisible.contactPerson" prop="contactPerson" label="联系人"></el-table-column>
        <el-table-column v-if="columnVisible.contactInfo" prop="contactInfo" label="联系方式"></el-table-column>
        <!--<el-table-column prop="bankName" label="银行名称"></el-table-column>-->
        <el-table-column v-if="columnVisible.aplicationDate" min-width="98px;" width="105px" prop="aplicationDate"
          label="申请时间" sortable :default-sort="{ prop: 'aplicationDate', order: 'descending' }"></el-table-column>
        <el-table-column v-if="columnVisible.status" prop="status" label="当前状态">
          <template #default="scope">
            <span :style="{ color: getProjectStatusColor(scope.row.status) }">
              {{ formatProjectStatus(scope.row.status).label }}
            </span>
          </template>
        </el-table-column>
        <el-table-column v-if="columnVisible.type" prop="type" label="订单类型"
          :formatter="formatProjectType"></el-table-column>
        <el-table-column v-if="columnVisible.estimatedAmount" prop="estimatedAmount"
          label="预估贷款金额(万)"></el-table-column>
        <el-table-column v-if="columnVisible.totalAmount" prop="totalAmount" label="贷款金额(万)">
          <template #default="scope">
            <span :style="{ color: scope.row.status === 'Confirm' ? '#FF7D00' : '' }">{{ scope.row.totalAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="columnVisible.salesRate" prop="salesRate" label="销售费率%"
          :formatter="formatRate"></el-table-column>
        <el-table-column v-if="columnVisible.purchaseRate" prop="purchaseRate" label="采购费率%"
          :formatter="formatRate"></el-table-column>
        <el-table-column v-if="columnVisible.taxRate" prop="taxRate" label="税率%"
          :formatter="formatRate"></el-table-column>
        <el-table-column v-if="columnVisible.prePaid" prop="prePaid" label="客户余额"></el-table-column>
        <!-- <el-table-column v-if="columnVisible.deposite" prop="deposite" label="预付金额"></el-table-column> -->
        <el-table-column v-if="columnVisible.completedAmount" prop="completedAmount" label="已完成金额"></el-table-column>
        <el-table-column v-if="columnVisible.balance" prop="balance" label="服务费"></el-table-column>
        <el-table-column v-if="columnVisible.taxes" prop="taxes" label="税金"></el-table-column>
        <el-table-column v-if="columnVisible.leftAmount" prop="leftAmount" label="订单余额"></el-table-column>
        <el-table-column v-if="columnVisible.unpaidAmount" prop="unpaidAmount" label="未收款金额">
          <template #default="scope">
            <span :class="{ 'warning-text': scope.row.paymentWarning }">{{ scope.row.unpaidAmount }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="columnVisible.userName" prop="user.username" label="负责人"></el-table-column>
        <el-table-column v-if="columnVisible.comment" prop="comment" label="备注" width="100">
          <template #default="scope">
            <div class="comment-content" :title="scope.row.comment">
              {{ scope.row.comment }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template #default="scope">
            <div class="project-buttons-container">
              <template v-for="button in getOperationButtons(scope.row, null)" :key="button.key">
                <el-button size="small" :type="button.type" @click="button.action(scope.row)"
                  :disabled="button.disabled">
                  {{ button.label }}
                </el-button>
              </template>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize"
          :page-sizes="[10, 20, 50, 100, 500]" layout="total, sizes, prev, pager, next, jumper" :total="totalProjects"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" v-model="dialogVisible" width="50%">
      <el-form :model="currentProject" :rules="rules" ref="projectForm" label-width="120px">
        <el-form-item label="订单名称" prop="name">
          <el-input v-model="currentProject.name"></el-input>
        </el-form-item>
        <el-form-item prop="orderMonth" label="订单月份">
          <el-date-picker v-model="currentProject.orderMonth" type="month" placeholder="选择订单月份" value-format="YYYY-MM"
            style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="type" label="订单类型">
          <el-select v-model="currentProject.type" placeholder="请选择订单类型" style="width: 100%">
            <el-option label="销售订单" value="Sales"></el-option>
            <el-option label="采购订单" value="Purchase"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称" prop="customer">
          <el-select v-model="currentProject.customer" placeholder="请选择客户名称" style="width: 100%"
            :disabled="currentProject.id" value-key="id" @change="handleCustomerChange" filterable>
            <el-option v-for="customer in customers" :key="customer.id" :label="customer.name" :value="customer">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="企业名称" prop="companyName">
          <el-input v-model="currentProject.companyName"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="纳税人识别码" prop="tin">
          <el-input v-model="currentProject.tin"></el-input>
        </el-form-item> -->
        <el-form-item prop="contactPerson" label="联系人">
          <el-input v-model="currentProject.contactPerson"></el-input>
        </el-form-item>
        <el-form-item prop="contactInfo" label="联系方式">
          <el-input v-model="currentProject.contactInfo"></el-input>
        </el-form-item>
        <!--<el-form-item prop="bankName" label="银行名称">
          <el-input v-model="currentProject.bankName"></el-input>
        </el-form-item>-->
        <el-form-item prop="aplicationDate" label="申请时间">
          <el-date-picker v-model="currentProject.aplicationDate" type="date" placeholder="选择日期"
            value-format="YYYY-MM-DD" style="width: 100%">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item prop="status" label="当前状态">
          <el-select v-model="currentProject.status" :disabled="currentProject.id==null">
            <el-option v-if="currentProject.id==null" label="新建" value="Initial"></el-option>
            <template v-else>
              <el-option label="新建" value="Initial"></el-option>
              <el-option label="审批" value="Approvaled"></el-option>
              <el-option label="复核" value="Recheck"></el-option>
              <el-option v-if="isAdmin" label="完成" value="Completed"></el-option>
              <el-option v-if="isAdmin" label="关闭" value="Closed"></el-option>
            </template>
          </el-select>
        </el-form-item>-->
        <el-form-item label="预估贷款金额(万)" prop="estimatedAmount">
          <el-input-number v-model="currentProject.estimatedAmount" :min="0" :precision="2"
            style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item v-if="currentProject.id && isAdmin" label="贷款金额(万)" prop="totalAmount">
          <el-input-number v-model="currentProject.totalAmount" :min="0" :precision="2"
            style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="销售费率%" prop="salesRate" :show-message="true">
          <el-input-number v-model="currentProject.salesRate" :min="0" :precision="6" :step="0.1"
            style="width: 100%"></el-input-number>
          <div v-if="currentProject.customer && latestRates.salesRate" class="el-form-item__error"
            style="margin-top: 5px;">
            提示: 该客户最近订单的销售费率为 {{ latestRates.salesRate }}%</div>
        </el-form-item>
        <el-form-item label="采购费率%" prop="purchaseRate" :show-message="true">
          <el-input-number v-model="currentProject.purchaseRate" :min="0" :precision="6" :step="0.1"
            style="width: 100%"></el-input-number>
          <div v-if="currentProject.customer && latestRates.purchaseRate" class="el-form-item__error"
            style="margin-top: 5px;">提示: 该客户最近订单的采购费率为 {{ latestRates.purchaseRate }}%</div>
        </el-form-item>
        <el-form-item label="税率%" prop="taxRate">
          <el-input-number v-model="currentProject.taxRate" :min="0" :precision="6" :step="0.1"
            style="width: 100%"></el-input-number>
        </el-form-item>
        <!-- <el-form-item label="已完成金额(税前)" prop="completedAmount">
          <el-input-number v-model="currentProject.completedAmount" :min="0" :precision="2" style="width: 100%"></el-input-number>
        </el-form-item> -->
        <el-form-item label="订单余额" prop="leftAmount">
          <el-input-number v-model="currentProject.leftAmount" :min="0" :precision="2"
            style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="comment">
          <el-input v-model="currentProject.comment" type="textarea" :autosize="{ minRows: 4, maxRows: 6 }"></el-input>
        </el-form-item>
        <el-form-item label="负责人" prop="user" v-if="isAdmin">
          <el-select v-model="currentProject.userId" placeholder="请选择负责人" style="width: 100%" filterable>
            <el-option v-for="operator in operators" :key="operator.id" :label="operator.username" :value="operator.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </template>
    </el-dialog>

    <el-dialog title="导出Excel设置" v-model="exportDialogVisible" width="30%">
      <el-form :model="exportForm" :rules="exportFormRules" ref="exportFormRef" label-width="100px">
        <el-form-item label="文件名称" prop="fileName">
          <el-input v-model="exportForm.fileName" placeholder="请输入文件名称"></el-input>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="exportForm.title" placeholder="请输入标题"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="exportDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmExport">确认导出</el-button>
      </template>
    </el-dialog>

    <el-dialog title="上传收款凭证" v-model="showUploadPaymentVisible" width="50%">
      <el-form :model="updatePaymentForm" :rules="paymentFormRules" ref="updatePaymentFormRef" label-width="100px">

        <el-form-item label="订单名称" prop="projectName">
          <el-input v-model="updatePaymentForm.projectName" disabled></el-input>
        </el-form-item>
        <el-form-item label="未收款金额" prop="unpaidAmount">
          <el-input v-model="updatePaymentForm.unpaidAmount" :min="0" :precision="2" style="width: 100%"
            disabled></el-input>
        </el-form-item>
        <el-form-item label="收款金额" prop="amount">
          <el-input-number v-model="updatePaymentForm.amount" :min="0" :precision="2"
            style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="收款凭证" prop="file">
          <el-upload class="avatar-uploader" :on-change="onChangePaymentFile" :file-list="paymentFileList"
            :auto-upload="false">
            <img v-if="paymentImageUrl" :src="paymentImageUrl" class="avatar" />
            <el-icon v-else class="avatar-uploader-icon">
              <Plus />
            </el-icon>
            <el-button slot="trigger" size="small" type="primary">选择文件</el-button>
            <!-- <el-button slot="upload" size="small" type="success">上传</el-button> -->
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showUploadPaymentVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPaymentUpdate">确认上传</el-button>
      </template>
    </el-dialog>

    <el-dialog title="上传实际贷款金额" v-model="showUploadLoanAmontVisible" width="50%">
      <el-form :model="updateLoanAmountForm" ref="updateLoanAmountFormRef" label-width="100px">
        <el-form-item label="订单名称" prop="projectName" label-width="30%">
          <el-input v-model="updateLoanAmountForm.projectName" disabled></el-input>
        </el-form-item>
        <el-form-item label="客户名称" prop="customerName" label-width="30%">
          <el-input v-model="updateLoanAmountForm.customerName" disabled></el-input>
        </el-form-item>
        <el-form-item label="预估贷款金额(万)" prop="estimatedAmount" label-width="30%">
          <el-input-number v-model="updateLoanAmountForm.estimatedAmount" :min="0" :precision="2" style="width: 100%"
            disabled></el-input-number>
        </el-form-item>
        <el-form-item label="实际贷款金额(万)" prop="loanAmount" label-width="30%">
          <el-input-number v-model="updateLoanAmountForm.amount" :min="0" :precision="2"
            style="width: 100%"></el-input-number>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="showUploadLoanAmontVisible = false">取消</el-button>
        <el-button type="primary" @click="submitLoanAmountUpdate">确认上传</el-button>
      </template>
    </el-dialog>

    <!-- 订单详情对话框 -->
    <el-dialog title="订单详情" v-model="detailsDialogVisible" width="80%">
      <div class="order-details-container">
        <h3>{{ detailsProject?.name }}</h3>
        <el-descriptions :column="2" border>
          <el-descriptions-item label="客户名称">{{ detailsProject?.customer?.name }}</el-descriptions-item>
          <el-descriptions-item label="联系人">{{ detailsProject?.contactPerson }}</el-descriptions-item>
          <el-descriptions-item label="联系方式">{{ detailsProject?.contactInfo }}</el-descriptions-item>
          <el-descriptions-item label="订单月份">{{ detailsProject?.orderMonth }}</el-descriptions-item>
          <el-descriptions-item label="申请时间">{{ detailsProject?.aplicationDate }}</el-descriptions-item>
          <el-descriptions-item label="当前状态">{{ formatProjectStatus(detailsProject?.status)?.label }}</el-descriptions-item>
          <el-descriptions-item label="订单类型">{{ formatProjectType(detailsProject) }}</el-descriptions-item>
          <el-descriptions-item label="预估贷款金额(万)">{{ detailsProject?.estimatedAmount }}</el-descriptions-item>
          <el-descriptions-item label="贷款金额(万)">{{ detailsProject?.totalAmount }}</el-descriptions-item>
          <el-descriptions-item label="销售费率%">{{ detailsProject?.salesRate }}</el-descriptions-item>
          <el-descriptions-item label="采购费率%">{{ detailsProject?.purchaseRate }}</el-descriptions-item>
          <el-descriptions-item label="税率%">{{ detailsProject?.taxRate }}</el-descriptions-item>
          <el-descriptions-item label="客户余额">{{ detailsProject?.prePaid }}</el-descriptions-item>
          <!-- <el-descriptions-item label="预付金额">{{ detailsProject?.deposite }}</el-descriptions-item> -->
          <el-descriptions-item label="已完成金额">{{ detailsProject?.completedAmount }}</el-descriptions-item>
          <el-descriptions-item label="服务费">{{ detailsProject?.balance }}</el-descriptions-item>
          <el-descriptions-item label="税金">{{ detailsProject?.taxes }}</el-descriptions-item>
          <el-descriptions-item label="订单余额">{{ detailsProject?.leftAmount }}</el-descriptions-item>
          <el-descriptions-item label="未收款金额">{{ detailsProject?.unpaidAmount }}</el-descriptions-item>
          <el-descriptions-item label="负责人">{{ detailsProject?.user?.username }}</el-descriptions-item>
          <el-descriptions-item label="备注" :span="3">{{ detailsProject?.comment }}</el-descriptions-item>
        </el-descriptions>
        
        <div class="payments-section">
          <h4>收款记录</h4>
          <el-table :data="detailsProject?.payments || []" style="width: 100%; max-height: 400px;">
            <el-table-column prop="type" label="收款类型" width="100">
              <template #default="scope">
                <span :style="{ color: scope.row.type === 1 ? '#67c23a' : '#409eff' }">
                  {{ scope.row.type === 1 ? '预付款' : '收款' }}
                </span>
              </template>
            </el-table-column>
             <el-table-column prop="amount" label="收款金额" width="120"></el-table-column>
            <el-table-column prop="createTime" label="收款时间" width="180"></el-table-column>
            <el-table-column prop="operator.username" label="收款人" width="100"></el-table-column>
            <el-table-column prop="auditedTime" label="审核时间" width="180"></el-table-column>
            <el-table-column prop="auditor.username" label="审核人" width="100"></el-table-column>   
            <el-table-column prop="attachmentPath" label="收款凭证" width="150">
              <template #default="scope1">
                <el-image style="width: 80px; height: 30px;" :src="scope1.row.attachmentPath" :zoom-rate="1.2"
                  :max-scale="7" :min-scale="0.2" :preview-src-list="[scope1.row.attachmentPath]" />
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <template #footer>
        <el-button @click="detailsDialogVisible = false">关闭</el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { ElMessage, ElMessageBox } from 'element-plus'
import { isSameMonth } from 'date-fns';
import { UserStatus, ProjectStatus } from '@/store'
import { reactive } from 'vue'

const paymentImageUrl = ref('')
const paymentRaw = ref()
const latestRates = ref({ salesRate: null, purchaseRate: null })




export default {
  setup() {
    const store = useStore()
    const dialogVisible = ref(false)
    const dialogTitle = ref('')
    const showWarningOnly = ref(false)
    const showCompleteProjects = ref(false)  // 控制是否显示已完成订单
    const showCustomerFirstProjectsMode = ref(false)  // 控制是否显示客户第一笔订单模式
    const customerFirstProjects = ref([])  // 存储客户第一笔订单数据
    const columnVisible = reactive({
      // customerName: true,
      contactPerson: true,
      contactInfo: true,
      aplicationDate: true,
      status: true,
      type: true,
      estimatedAmount: true,
      totalAmount: true,
      salesRate: true,
      purchaseRate: true,
      taxRate: true,
      prePaid: true,
      deposite: true,
      completedAmount: true,
      balance: true,
      taxes: true,
      unpaidAmount: true,
      leftAmount: true,
      userName: true,
      comment: true
    })
    // 分页相关变量
    const currentPage = ref(1)
    const pageSize = ref(20)
    const totalProjects = ref(0)
    const currentProject = ref({
      id: null,
      name: '',
      customer: null,
      userId: null,
      totalAmount: 0,
      completedAmount: 0,
      comment: '',
    })

    const searchForm = ref({
      name: '',
      customerName: '',
      contactPerson: '',
      username: '',
      orderMonth: '',
      paymentWarning: false,
      // aplicationDate: null,
      status: ''
    })

    const exportForm = ref({
      fileName: '',
      title: ''
    })

    const updatePaymentForm = ref({
      projectId: null,
      projectName: '',
      unpaidAmount: 0,
      amount: 0,
      file: null,
    })

    // Add missing selectedProjectIds declaration
    const selectedProjectIds = ref([])

    // Add missing exportDialogVisible declaration
    const exportDialogVisible = ref(false)

    const showUploadPaymentVisible = ref(false)

    const showUploadLoanAmontVisible = ref(false)
    const detailsDialogVisible = ref(false)
    const detailsProject = ref(null)

    const updateLoanAmountForm = ref({
      projectId: null,
      projectName: '',
      customerName: '',
      estimatedAmount: 0,
      loanAmount: 0,
    })

    const exportFormRules = {
      fileName: [{ required: true, message: '请输入文件名称', trigger: 'blur' }],
      title: [{ required: true, message: '请输入标题', trigger: 'blur' }]
    }
    const paymentFormRules = {
      amount: [{ required: true, message: '请输入收款金额', trigger: 'blur' }],
      file: [{ required: true, message: '请上传收款凭证', trigger: 'change' }],

    }

    const rules = {
      // name: [{ required: true, message: '请输入订单名称', trigger: 'blur' }],
      type: [{ required: true, message: '请选择订单类型', trigger: 'change' }],
      customer: [{ required: true, message: '请选择客户', trigger: 'change' }],
      userId: [{ required: true, message: '请选择负责人', trigger: 'change' }],
      aplicationDate: [{ required: true, message: '请选择申请日期', trigger: 'change' }],
    }

    const customers = computed(() => store.state.customers.filter(c => c.status !== 'Blacklist'))
    const projects = computed(() => store.state.projects)
    const optor = computed(() => store.state.user)
    const optorRole = computed(() => store.state.role)
    const isAdmin = computed(() => optor.value?.role === 'ADMIN')
    const operators = computed(() => {
      return store.state.users.filter(user =>
        user.status === UserStatus.APPROVED.value
      )
    })

    const filteredProjects = computed(() => {
      // 如果处于客户第一笔订单模式，直接返回客户第一笔订单数据
      let result = []
      if (showCustomerFirstProjectsMode.value) {
        result = customerFirstProjects.value
        result.forEach(p => {
          if (p.status === ProjectStatus.Audit.value || p.status === ProjectStatus.Check.value || p.status === ProjectStatus.PreAudit.value || p.status === ProjectStatus.PreCheck.value) {
            p.hasChildren = true
          } else if (p.status === ProjectStatus.Payment.value && p.completedAmount > 0) {
            p.hasChildren = true
          } else {
            p.hasChildren = false
          }
          p.payments = []
        })
      } else {
        result = Array.isArray(store.state.projects) ? store.state.projects : []
        if (showWarningOnly.value) {
          result = result.filter(p => p.paymentWarning)
        }
        // 如果选择了只显示已完成订单
        if (showCompleteProjects.value) {
          result = result.filter(p =>
            p.status === ProjectStatus.Completed.value ||
            p.status === ProjectStatus.Closed.value
          )
        }
        result.forEach(p => {
          if (p.status === ProjectStatus.Audit.value || p.status === ProjectStatus.Check.value || p.status === ProjectStatus.PreAudit.value || p.status === ProjectStatus.PreCheck.value) {
            p.hasChildren = true
          } else if (p.status === ProjectStatus.Payment.value && p.completedAmount > 0) {
            p.hasChildren = true
          } else {
            p.hasChildren = false
          }
          p.payments = []
        })
      }
      // console.log("filter project:",result)
      return result;
      // return result.filter(project => {
      //   return (
      //     (!searchForm.value.name || project.name.includes(searchForm.value.name)) &&
      //     (!searchForm.value.customerName || project.customer.name.includes(searchForm.value.customerName)) &&
      //     (!searchForm.value.contactPerson || project.contactPerson.includes(searchForm.value.contactPerson)) &&
      //     (!searchForm.value.username || project.user.username.includes(searchForm.value.username)) &&
      //     (!searchForm.value.aplicationDate || isSameMonth(new Date(project.aplicationDate), searchForm.value.aplicationDate)) &&
      //     (!searchForm.value.status || project.status.includes(searchForm.value.status)) &&
      //     (!searchForm.value.orderMonth || isSameMonth(new Date(project.orderMonth), searchForm.value.orderMonth)) &&
      //     (!searchForm.value.type || project.type.includes(searchForm.value.type))
      //   )
      // })
    })

    onMounted(() => {
      store.dispatch('fetchCustomers')
      fetchProjectsWithPagination()
      if (isAdmin.value) {
        store.dispatch('fetchUsers')
      }
    })

    // 带分页的订单数据获取
    const fetchProjectsWithPagination = () => {
      // 使用getPaginProjectsByQuery方法进行分页查询，传入searchForm作为查找条件
      store.dispatch('getPaginProjectsByQuery', {
        pagination: {
          currentPage: currentPage.value,
          pageSize: pageSize.value
        },
        query: {
          ...searchForm.value,
          optor: searchForm.value.username,
          isWarning: searchForm.value.paymentWarning || false,
          includedComplete: showCompleteProjects.value
        }
      }).then(response => {
        // 更新总条数和当前页码
        if (response && response.total !== undefined) {
          totalProjects.value = response.total
          currentPage.value = response.currentPage || currentPage.value
        }
      })
        .catch(error => {
          console.error('Error fetching projects with pagination:', error);
          ElMessage.error('获取订单数据失败');
        })
    }

    // 分页大小变化处理
    const handleSizeChange = (size) => {
      pageSize.value = size
      fetchProjectsWithPagination()
    }

    // 当前页码变化处理
    const handleCurrentChange = (current) => {
      currentPage.value = current
      fetchProjectsWithPagination()
    }

    const showAddDialog = () => {
      dialogTitle.value = '新增订单'
      currentProject.value = {
        id: null,
        name: '',
        contactPerson: '',
        contactInfo: '',
        bankName: '',
        aplicationDate: null,
        status: "Initial",
        type: '',
        estimatedAmount: 0,
        unpaidAmount: 0,
        customer: null,
        user: null,
        totalAmount: 0,
        salesRate: 0,
        purchaseRate: 0,
        taxRate: 0,
        balance: 0,
        completedAmount: 0,
      }
      latestRates.value = { salesRate: null, purchaseRate: null }
      dialogVisible.value = true
    }

    const filterWarningProjects = () => {
      searchForm.value.paymentWarning = true
      // 重置到第一页并重新获取数据
      currentPage.value = 1
      fetchProjectsWithPagination()
      searchForm.value.paymentWarning = false
    }

    const filterCompleteProjects = () => {
      showCompleteProjects.value = !showCompleteProjects.value
      // 切换已完成订单时，取消预警订单过滤
      if (showCompleteProjects.value) {
        showWarningOnly.value = false
      }
      // 重置到第一页并重新获取数据
      currentPage.value = 1
      fetchProjectsWithPagination()
    }

    const handleSearch = () => {
      // 重置到第一页并执行搜索
      currentPage.value = 1
      fetchProjectsWithPagination()
    }

    const handleCustomerChange = (customer) => {
      if (customer) {
        // 自动填充联系人和联系方式
        currentProject.value.contactPerson = customer.contactPerson || '';
        currentProject.value.contactInfo = customer.contactInfo || '';

        store.dispatch('getCustomerLatestProject', customer.id)
          .then(res => {
            if (res) {
              latestRates.value = {
                salesRate: res.salesRate,
                purchaseRate: res.purchaseRate
              }
            }
          })
          .catch(error => {
            console.error('获取客户最近订单费率失败:', error)
          })
      } else {
        latestRates.value = { salesRate: null, purchaseRate: null }
      }
    }

    // 切换显示客户第一笔订单或未完成订单
    const showCustomerFirstProjects = () => {
      if (showCustomerFirstProjectsMode.value) {
        // 如果当前是显示客户第一笔订单模式，则切换回正常模式
        showCustomerFirstProjectsMode.value = false
        // 重置到第一页并重新获取数据
        currentPage.value = 1
        fetchProjectsWithPagination()  // 使用新的分页查询方法重新获取数据
      } else {
        // 否则，显示客户第一笔订单
        store.dispatch('getCustomerFirstProject')
          .then(response => {
            if (response && response.data) {
              customerFirstProjects.value = response.data
              // 清空当前搜索条件
              resetSearch()
              // 切换到客户第一笔订单模式
              showCustomerFirstProjectsMode.value = true
              totalProjects.value = customerFirstProjects.value.length
            }
          })
          .catch(error => {
            console.error('获取客户第一笔订单失败:', error)
            ElMessage.error('获取客户第一笔订单失败，请重试')
          })
      }
    }

    const resetSearch = () => {
      searchForm.value = {
        name: '',
        companyName: '',
        contact: '',
        username: '',
        // aplicationDate: null,
        status: '',
        type: ''
      }
      fetchProjectsWithPagination()
      // 重置显示模式
      showCustomerFirstProjectsMode.value = false
      // 如果有paymentWarning过滤条件，也需要移除
      delete searchForm.value.paymentWarning
    }

    const handleEdit = (project) => {
      dialogTitle.value = '编辑订单'
      currentProject.value = {
        ...project,
        customer: customers.value.find(c => c.id === project.customer.id),
        user: operators.value.find(u => u.id === project.user.id),
      }
      // 获取客户最近订单费率
      if (currentProject.value.customer) {
        store.dispatch('getCustomerLatestProject', currentProject.value.customer.id)
          .then(res => {
            if (res) {
              latestRates.value = {
                salesRate: res.salesRate,
                purchaseRate: res.purchaseRate
              }
            }
          })
          .catch(error => {
            console.error('获取客户最近订单费率失败:', error)
          })
      }
      dialogVisible.value = true
    }

    const handleDelete = (id) => {
      ElMessageBox.confirm('确认删除该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('deleteProject', id)
          .then(() => {
            ElMessage.success('删除成功')
            fetchProjectsWithPagination()
          })
          .catch(error => {
            console.error('删除订单失败:', error)
            ElMessage.error('删除失败，请重试')
          })
      }).catch(() => { })
    }

    const submitForm = async () => {
      try {
        if (currentProject.value.id) {
          await store.dispatch('updateProject', { ...currentProject.value, userId: currentProject.value.userId, customerId: currentProject.value.customer?.id })
            .then(res => {
              if (res) {
                ElMessage.success('更新成功')
              }
            }).catch(error => {
              ElMessage.error('更新失败:' + (error.response?.data?.message || error.message))
            })
        } else {
          if (currentProject.value.name === null) {
            ElMessage.error('请输入订单名称')
            return
          }
          if (currentProject.value.type === null) {
            ElMessage.error('请选择订单类型')
            return
          }
          if (currentProject.value.customer === null) {
            ElMessage.error('请选择客户')
            return
          }
          if (currentProject.value.aplicationDate === null) {
            ElMessage.error('请输入申请日期')
            return
          }
          await store.dispatch('createProject', { ...currentProject.value, userId: currentProject.value.userId, customerId: currentProject.value.customer?.id })
            .then(res => {
              if (res.status === 200) {
                ElMessage.success('新增成功')
              } else if (res.code === 5001) {
                ElMessage.error('新增失败:该用户当月此类型订单已存在')
                return
              }
            })
        }
        dialogVisible.value = false
        fetchProjectsWithPagination()
      } catch (error) {
        console.error('提交表单失败:', error)
        ElMessage.error('操作失败，请重试')
      }
    }

    const formatProjectType = (input) => {
      // 处理直接传递的字符串值
      if (typeof input === 'string') {
        if (input === 'Purchase') return '采购订单'
        if (input === 'Sales') return '销售订单'
        return input || '未知类型'
      }
      // 处理传递的对象
      if (input && typeof input === 'object') {
        if (input.type === 'Purchase') return '采购订单'
        if (input.type === 'Sales') return '销售订单'
        return input.type || '未知类型'
      }
      return '未知类型'
    }

    const formatProjectStatus = (status) => {
      return Object.values(ProjectStatus).find(s => s.value === status)
    }

    const getProjectStatusColor = (rowStatus) => {
      const status = formatProjectStatus(rowStatus)
      // if (!status) return '未知状态'
      switch (status.value) {
        case ProjectStatus.New.value:
          return 'blue'
        case ProjectStatus.Approvaled.value:
        case ProjectStatus.Check.value:
        case ProjectStatus.Confirm.value:
          return 'green'
        case ProjectStatus.Initial.value:
          return '#999933'
        case ProjectStatus.Payment.value:
        case ProjectStatus.Audit.value:
          return 'orange'
        case ProjectStatus.Completed.value:
          return '#7CCD7C'
        case ProjectStatus.Closed.value:
          return '#7D9EC0'
        // return 'gray'
        default:
          return 'default'
      }
    }
    const formatRate = (row, column, value) => {
      return value ? value.toFixed(2) + '%' : '0.00%'
    }

    // Add Excel export related methods
    const handleSelectionChange = (selection) => {
      selectedProjectIds.value = selection.map(item => item.id)
    }

    const loadPayments = async (tree, treeNode, resolve) => {
      if (tree.hasChildren) {
        fetchPayments(tree.id).then(res => {
          // console.log("fetchPayments:",res)
          resolve(res)
        })
        // setTimeout(() => {
        //     const  children = fetchPayments(tree.id);
        //     console.log("loadPayment:",children)
        //     // tree.payments = children;
        //     resolve(children)
        //   }, 1000);
      } else {
        resolve([]);
      }
    }

    const handleExpandPayment = (row, expanded) => {
      // console.log('handleExpandPayment:', row)
      if (row.hasChildren) {
        fetchPayments(row.id).then(res => {
          // 按createTime倒序排序
          res.sort((a, b) => {
            return new Date(b.createTime) - new Date(a.createTime)
          })
          // console.log("fetchPayments:",res)
          row.payments = res
        })
      }
      // if (expanded) {
      //  this.
      // }
    }

    const rowClassName = ({ row, rowIndex }) => {
      row.index = rowIndex
      if (row.hasChildren) {
        return 'row-show-icon'
      } else {
        return 'row-hidden-expand-icon'
      }
    }

    const exportSelectedProjects = () => {
      if (selectedProjectIds.value.length === 0) {
        ElMessage.warning('请先选择要导出的订单')
        return
      }
      exportDialogVisible.value = true
    }

    const confirmExport = async () => {
      try {
        const fileName = (exportForm.value.fileName.endsWith('.xlsx')) ? exportForm.value.fileName : exportForm.value.fileName + '.xlsx';

        const data = await store.dispatch('exportExcel', {
          fileName: fileName,
          title: exportForm.value.title,
          listId: selectedProjectIds.value
        })

        const link = document.createElement('a');
        link.href = URL.createObjectURL(data);

        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        ElMessage.success('Excel导出成功')
        exportDialogVisible.value = false
        exportForm.value = {
          fileName: '',
          title: ''
        }
      } catch (error) {
        ElMessage.error('导出失败，请重试')
      }
    }

    const onChangePaymentFile = (file) => {
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
      if (!['jpg', 'jpeg', 'png', 'gif'].includes(fileExtension)) {
        ElMessage.error('请上传图片文件（*.jpg, *.jpeg, *.png, *.gif）')
        return false
      }
      if (file.size > 2 * 1024 * 1024) { // 限制文件大小为2MB
        ElMessage.error('文件大小不能超过2MB')
        return false
      }
      paymentImageUrl.value = URL.createObjectURL(file.raw)
      paymentRaw.value = file.raw
      ElMessage.success('图片已选择')
      return true
    }

    const submitPaymentUpdate = () => {
      if (!updatePaymentForm.value.amount) {
        ElMessage.error('请输入收款金额')
        return
      }
      if (!paymentRaw.value) {
        ElMessage.error('请上传收款凭证')
        return

      }

      const formData = new FormData()
      formData.append('projectId', updatePaymentForm.value.projectId)
      formData.append('amount', updatePaymentForm.value.amount)
      formData.append('file', paymentRaw.value ? paymentRaw.value : null)

      // console.log('提交收款数据:', formData)
      store.dispatch('paid', formData)
        .then(() => {
          showUploadPaymentVisible.value = false
          ElMessage.success('收款更新成功')
          fetchProjectsWithPagination()
        })
        .catch(error => {
          console.error('收款更新失败:', error)
          ElMessage.error('收款更新失败，请重试')
        })
    }

    const submitLoanAmountUpdate = () => {
      if (!updateLoanAmountForm.value.amount) {
        ElMessage.error('请输入实际贷款金额')
        return
      }
      const checkDto = {
        projectId: updateLoanAmountForm.value.projectId,
        amount: updateLoanAmountForm.value.amount,
      }

      // console.log('提交实际贷款金额数据:', formData)
      store.dispatch('checked', checkDto)
        .then(() => {
          showUploadLoanAmontVisible.value = false
          ElMessage.success('贷款金额更新成功')
          fetchProjectsWithPagination()
        })
        .catch(error => {
          console.error('贷款金额更新失败:', error)
          ElMessage.error('贷款金额更新失败，请重试')
        })
    }

    // 确定操作按钮的方法
    const getOperationButtons = (project, child) => {
      const buttons = []
      const status = project.status
      const role = optorRole.value
      // 管理员可以编辑所有状态的订单
      if (child == null && role === 'ADMIN' || (role === 'MANAGER' || role === 'SUPERVISOR') && (status === ProjectStatus.Initial.value || status === ProjectStatus.Approvaled.value || status === ProjectStatus.New.value)) {

        buttons.push({
          key: 'edit',
          label: '编辑',
          type: 'default', // 默认色
          action: handleEdit,
          disabled: status === ProjectStatus.Completed.value || status === ProjectStatus.Closed.value
        })
      }
      // 根据不同状态显示特定按钮
      switch (status) {
        case ProjectStatus.New.value:
          if (role === 'ADMIN' || role === 'MANAGER' || role === 'SUPERVISOR') {
            buttons.push({
              key: 'approve',
              label: '批准',
              type: 'primary', // 蓝色
              action: (row) => handleApprove(row.id),
              disabled: false
            }
            // ,{
            //   key: 'paid',
            //   label: '预收款',
            //   type: 'warning', // 黄色
            //   action: handlePaid,
            //   disabled: false
            // }
          )
          }
          break
        case ProjectStatus.Approvaled.value:
          //  buttons.push({
          //     key: 'paid',
          //     label: '预收款',
          //     type: 'warning', // 黄色
          //     action: handlePaid,
          //     disabled: false
          //   })
        case ProjectStatus.Confirm.value:
          if (role === 'ADMIN' && child == null) {
            buttons.push({
              key: 'accept',
              label: '核准',
              type: 'success', // 绿色
              action: (row) => handleAccept(row.id),
              disabled: false
            })
            if (role === 'ADMIN' && child == null && status != ProjectStatus.Approvaled.value) {
              buttons.push({
                key: 'reject',
                label: '驳回',
                type: 'danger', // 红色
                action: (project) => handleReject(project.id, null),
                disabled: false
              })
            }
          }
          break
        case ProjectStatus.PreCheck.value:
        case ProjectStatus.Check.value:
          if (role === 'ADMIN' && child != null && child.approvedTime == null) {
            buttons.push({
              key: 'accept',
              label: '核准',
              type: 'success', // 绿色
              action: (row, project) => handleAccept(project.id, row.id),
              disabled: false
            })
          }
          break
        case ProjectStatus.Initial.value:
          if (role === 'ADMIN' || role === 'OTHER') {
            buttons.push({
              key: 'confirm',
              label: '实贷',
              type: 'info',
              // 使用组件样式需要深度定制:deep(.el-button--info) {
              //   background-color: #993333;
              //   color: #fff;
              // }
              // style: 'background-color: #993333 !important; color: white !important;',
              action: (row) => handleCheck(row),
              disabled: false
            }
            // ,{
            //   key: 'paid',
            //   label: '预收款',
            //   type: 'warning', // 黄色
            //   action: handlePaid,
            //   disabled: false
            // }
          )
          }
          break
        case ProjectStatus.Payment.value:
          if (child == null && role === 'ADMIN' || role === 'USER') {
            buttons.push({
              key: 'paid',
              label: '收款',
              type: 'warning', // 黄色
              action: handlePaid,
              disabled: false
            })
          }
          break
        case ProjectStatus.PreAudit.value:
        case ProjectStatus.Audit.value:
          if (child != null && child.auditor == null && (role === 'ADMIN' || role === 'ACCOUNTANT')) {
            buttons.push({
              key: 'audit',
              label: '验款',
              type: 'warning', // 黄色
              action: (row) => handleAudit(row.id),
              disabled: false
            }, {
              key: 'reject',
              label: '驳回',
              type: 'danger', // 红色
              action: (row, project) => handleReject(project.id, row.id),
              disabled: false
            })
          }
          break
        case ProjectStatus.Completed.value:
        case ProjectStatus.Closed.value:
        buttons.push({
              key: 'details',
              label: '详情',
              type: 'primary', // 蓝色
              action: (row) => handleDetails(row.id),
              disabled: false
            })
          break
      }
  
      // 管理员可以删除未完成和未关闭的订单
      if (child == null && role === 'ADMIN' || (role !== 'ACCOUNTANT' && role !== 'OTHER' && status === ProjectStatus.New.value)) {
        buttons.push({
          key: 'delete',
          label: status === ProjectStatus.New.value ? '删除' : '关闭',
          type: 'danger',
          action: (row) => handleDelete(row.id),
          disabled: status === ProjectStatus.Completed.value || status === ProjectStatus.Closed.value
        })
      }
      // }else{

      // }

      return buttons
    }

    // 处理订单批准
    const handleApprove = (id) => {
      ElMessageBox.confirm('确认批准该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // type: 'info'
      }).then(() => {
        store.dispatch('approved', id)
          .then(() => {
            ElMessage.success('批准成功')
            fetchProjectsWithPagination()
          })
          .catch(error => {
            console.error('批准订单失败:', error)
            ElMessage.error('批准失败，请重试')
          })
      }).catch(() => { })
    }

    const handleAccept = (id, paymentId) => {
      // console.log('handleAccept id:', id)
      // console.log('handleAccept paymentId:', paymentId)
      ElMessageBox.confirm('确认核准该订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        store.dispatch('accepted', { projectId: id, paymentId: paymentId ? paymentId : null })
          .then(() => {
            ElMessage.success('核准成功')
            fetchProjectsWithPagination()
          })
          .catch(error => {
            console.error('核准订单失败:', error)
            ElMessage.error('核准失败，请重试')
          })
      }).catch(() => { })

    }

    // 处理订单核账
    const handleCheck = (project) => {
      updateLoanAmountForm.value = {
        projectId: project.id,
        projectName: project.name,
        customerName: project.customer.name,
        estimatedAmount: project.estimatedAmount,
        amount: 0,
      }
      showUploadLoanAmontVisible.value = true
    }

    const handlePaid = (project) => {
      // 重置收款表单
      updatePaymentForm.value = {
        projectId: project.id,
        projectName: project.name,
        unpaidAmount: project.unpaidAmount,
        amount: 0,
        file: null,
      }
      // 重置图片
      paymentImageUrl.value = ''
      paymentRaw.value = null

      // 显示对话框
      showUploadPaymentVisible.value = true
      // console.log('打开收款对话框:', showUploadPaymentVisible.value)
    }

    const handleReject = (id, paymentId) => {
      // console.log('handleReject id:', id)
      // console.log('handleReject paymentId:', paymentId)
      ElMessageBox.confirm('确认驳回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        store.dispatch('rejected', { projectId: id, paymentId: paymentId ? paymentId : null })
          .then(() => {
            ElMessage.success('驳回成功')
            fetchProjectsWithPagination()
          })
          .catch(error => {
            // console.error('驳回失败:', error)
            ElMessage.error('驳回失败，请重试')
          })
      }).catch(() => { })
    }

    const handleDetails = async (id) => {
      try {
        // 获取订单详情
        const project = filteredProjects.value.find(p => p.id === id)
        if (project) {
          // 获取该订单的payments
          const payments = await fetchPayments(id)
          // 按createTime顺序排序
          payments.sort((a, b) => new Date(a.createTime) - new Date(b.createTime))
          
          detailsProject.value = {
            ...project,
            payments: payments
          }
          detailsDialogVisible.value = true
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        ElMessage.error('获取订单详情失败，请重试')
      }
    }

    const handleAudit = (id) => {
      // console.log('handleAudit id:', id)
      ElMessageBox.confirm('确认该账单正确吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        // type: 'info'
      }).then(() => {
        store.dispatch('audited', id)
          .then(() => {
            ElMessage.success('对账成功')
            fetchProjectsWithPagination()
          })
          .catch(error => {
            console.error('对账失败:', error)
            ElMessage.error('对账失败，请重试')
          })
      }).catch(() => { })
    }

    const fetchPayments = async (projectId) => {
      try {
        return await store.dispatch('getProjectPayment', projectId);
      } catch (error) {
        console.error('获取收款记录失败:', error);
        return [];
      }
    }

    return {
      customers,
      projects,
      operators,
      isAdmin,
      optorRole,
      // manager,
      filteredProjects,
      dialogVisible,
      dialogTitle,
      currentProject,
      rules,
      searchForm,
      showAddDialog,
      filterWarningProjects,
      handleEdit,
      handleDelete,
      submitForm,
      handleSearch,
      resetSearch,
      formatRate,
      formatProjectType,
      formatProjectStatus,
      ProjectStatus,
      getProjectStatusColor,
      onChangePaymentFile,
      paymentFormRules,
      submitPaymentUpdate,
      showUploadPaymentVisible,
      showUploadLoanAmontVisible,
      submitLoanAmountUpdate,
      updatePaymentForm,
      updateLoanAmountForm,
      loadPayments,
      handleExpandPayment,
      handleDetails,
      detailsDialogVisible,
      detailsProject,
      rowClassName,
      latestRates,
      handleCustomerChange,

      // Add Excel export related properties and methods
      selectedProjectIds,
      exportDialogVisible,
      exportForm,
      exportFormRules,
      handleSelectionChange,
      exportSelectedProjects,
      confirmExport,
      // 分页相关
      currentPage,
      pageSize,
      totalProjects,
      // 列控制
      columnVisible,
      handleSizeChange,
      handleCurrentChange,
      // 过滤相关
      showCompleteProjects,
      filterCompleteProjects,
      showCustomerFirstProjectsMode,
      customerFirstProjects,
      showCustomerFirstProjects,
      // 新增的操作按钮方法
      getOperationButtons,
      handleAccept,
      handleApprove,
      handleCheck,
      handlePaid,
      handleAudit,
      handleReject,
      fetchPayments,
    }
  }
}

</script>

<style scoped>
.project-container {
  padding: 20px;
}

.comment-content {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  cursor: pointer;
}

.warning-text {
  color: #f56c6c;
  font-weight: bold;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* 子表覆盖右侧fix */
::v-deep .el-table__body-wrapper {
  .el-table__expand-cell {
    z-index: 100;
  }

}

:deep(.el-table .row-hidden-expand-icon) {
  td {
    &:first-child {
      .el-icon {
        visibility: hidden;
      }
    }
  }

  .el-table__expand-icon {
    pointer-events: none;
  }
}

:deep(.el-button--info) {
  background-color: #999933;
  color: #fff;
}

::v-deep .row-show-icon {
  td {
    &:first-child {
      .cell {
        height: 24px;
      }
    }
  }
}

/* 状态颜色样式 */
.status-blue {
  color: #409EFF;
}

.status-green {
  color: #67C23A;
}

.status-yellow {
  color: #E6A23C;
}

.status-purple {
  color: #909399;
}

.status-gray {
  color: #909399;
}

.status-red {
  color: #F56C6C;
}

.status-default {
  color: #303133;
}

.sub-table-container {
  width: 95%;
  margin-left: auto;
  background-color: #f5f5f5;
  padding: 10px;
}

.project-buttons-container {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.project-buttons-container .el-button {
  flex: 1;
  min-width: 60px;
  text-align: center;
}

.expand-scroll-container {
  width: 90%;
  /* 和主表宽度一致 */
  overflow-x: auto;
  /* 横向滚动 */
  padding: 1px 0;
  /* 可选：增加内边距 */
  margin-left: auto;
  /* 右对齐 */
}
</style>
